module.exports = __webpack_public_path__ + "static/media/archived.10084da0.svg";